import { func, shape, string } from "prop-types";
import { useSelector } from "react-redux";
import {
  selectIsEditing,
  selectIsLockedByAnotherUser,
} from "slices/proposalOutline/selectors";

import ActionsButton from "./ActionsButton";
import StartWritingButton from "./StartWritingButton";

const ActionsCell = ({ getTable, row }) => {
  const isEditing = useSelector(selectIsEditing);
  const isLockedByOtherUser = useSelector(selectIsLockedByAnotherUser);

  const { id: rowId, title, nextgenDocumentId, nextgenFileName } =
    row.original;

  if (!nextgenDocumentId && !isEditing && !isLockedByOtherUser) {
    return <StartWritingButton row={row} />;
  }

  return (
    <ActionsButton
      getTable={getTable}
      isEditing={isEditing}
      isLockedByOtherUser={isLockedByOtherUser}
      nextgenDocumentId={nextgenDocumentId}
      nextgenFileName={nextgenFileName}
      row={row}
      sectionId={rowId}
      title={title}
    />
  );
};

ActionsCell.propTypes = {
  getTable: func,
  row: shape({
    original: shape({
      title: string,
    }),
  }),
};

export default ActionsCell;
